import backendUrl from "./backendUrl";

export const authApi = {
  signUP: {
    url: `${backendUrl}/api/signup`,
    method: "post",
  },
  signIn: {
    url: `${backendUrl}/api/signin`,
    method: "post",
  },
  current_user: {
    url: `${backendUrl}/api/user-details`,
    method: "get",
  },
  logout_user: {
    url: `${backendUrl}/api/userLogout`,
    method: "post",
  },
  updatePassword: {
    url: `${backendUrl}/api/update-password`,
    method: "put",
  },
  forgotPassword: {
    url: `${backendUrl}/api/forgot-password`,
    method: "post",
  },
  resetPassword: {
    url: `${backendUrl}/api/reset-password`,
    method: "post",
  },
  getCaptcha: {
    url: `${backendUrl}/api/get-captcha`,
    method: "get",
  },
  getCsrfToken: {
    url: `${backendUrl}/api/csrf-token`,
    method: "get",
  },
};
